import { CnActionSheet as CnActionSheetView } from './action-sheet';
import open from './open';
import './styles/index.scss';
// @ts-ignore
const CnActionSheet = CnActionSheetView;
CnActionSheet.show = open;
export { CnActionSheet };
